import { render, staticRenderFns } from "./RadarChartSvg.vue?vue&type=template&id=cf8b75d6&"
import script from "./RadarChartSvg.vue?vue&type=script&lang=ts&"
export * from "./RadarChartSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports